<template>
  <b-col>
    <span v-for="(meetingRecord, index) in meetingRecords" :key="meetingRecord.id">
      <b-row
        v-if="
          meetingRecord.is_listed &&
          meetingRecord.vimeo &&
          meetingRecord.vimeo.upload_status == 'complete' &&
          (meetingRecord.vimeo.sourceFile || meetingRecord.vimeo.video_link)
        "
        class="mb-4 flex-nowrap"
      >
        <a
          class="card-img-wrapper rounded mr-4"
          href="javascript:void(0)"
          @click="showModalVideo(meetingRecord.id)"
        >
          <img
            :src="require(`@/assets/default-cover-video.jpg`)"
            alt="Rounded image"
            class="img-fluid rounded thumbnail img-content"
          />
        </a>

        <div class="meeting-record__content pt-1">
          <h5 class="meeting-record__title">Recording {{ index + 1 }}</h5>

          <p class="meeting-record__duration text-black-50">
            Duration: {{ computeDuration(meetingRecord) }}
          </p>
        </div>
        <!-- <b-col cols="12" class=""> -->

        <!-- <a class="card-img-wrapper rounded" href="javascript:void(0)">
                <b-embed type="video" controls>
                <source
                    :src="meetingRecord.vimeo"
                    type="video/mp4"
                />
                </b-embed>
            </a> -->
        <!-- </b-col> -->
        <view-video-and-chat-modal
          :post="post"
          :index="meetingRecord.id"
          :meeting-record="meetingRecord"
        ></view-video-and-chat-modal>
      </b-row>
    </span>
  </b-col>
</template>

<script>
import { datetimeMixin } from '@/mixins/datetimeMixin';
import ViewVideoAndChatModal from '@/views/VideoConference/components/ViewVideoAndChatModal';
import Post from '@/models/Post';
export default {
  components: {
    ViewVideoAndChatModal
  },
  mixins: [datetimeMixin],

  props: {
    post: {
      type: Post,
      default: () => ({})
    },

    meetingRecords: {
      type: Array,
      required: true
    }
  },

  data() {
    return {};
  },

  methods: {
    computeDuration(meetingRecord) {
      let duration = '00:00:00';

      if (meetingRecord.vimeo) {
        const vimeoDuration = meetingRecord.vimeo.duration;

        duration = this.convertHMS(vimeoDuration);
      }

      return duration;
    },

    showModalVideo(id) {
      this.$bvModal.show(`modal__view_video-${id}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.img-content {
  min-width: 160px;
  max-width: 160px;
  height: 100px;
  max-height: max-content;
}
</style>
